import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定");

import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getVexTableProps } from '@/config';
import { getMerchandiseBlacklistChooseListBySupplierId, saveMerchandiseBlacklistListBySupplierId } from '@/request';
export default {
  name: 'MerchandiseBlacklistChooseModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      default: ''
    },
    dept: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const keyword = ref('');
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        keyword.value = '';
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });

    function saveBlacklist() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      saveMerchandiseBlacklistListBySupplierId({
        ids: selectRows.map(i => i.supAccountId).join(','),
        supplierId: props.supplierId,
        prodNo: props.row.prodNo,
        __repeat: true,
        __warn: true
      }).then(data => {
        if (data.success) {
          ElMessage.success('操作成功!');
          visible.value = false;
          emit('success');
        } else {
          ElMessage.error(data.msg);
        }
      });
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      pagerConfig: {
        pageSize: 5
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return row.supAccountId;
        }

      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '登录账号',
        field: 'loginName',
        width: '200px',
        showOverflow: true
      }, {
        title: '姓名',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '联系电话',
        field: 'linkPhone',
        width: '200px',
        showOverflow: true
      }, {
        title: '业务员类型',
        field: 'salesmanType',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getMerchandiseBlacklistChooseListBySupplierId({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: props.supplierId,
              structureId: Number(props.dept.levelType) === 0 ? '' : props.dept.id,
              prodNo: props.row.prodNo,
              keyword: keyword.value,
              __warn: true
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择业务员",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => saveBlacklist())
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table,
          style: {
            "margin-top": "5px"
          }
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "200px",
                "margin-right": "10px"
              },
              modelValue: keyword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
              placeholder: "账号/联系人"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};